import { ReactNode } from 'react';
import styles from './Modal.module.scss';
import closeIcon from '@image/close-icon.svg';

interface ModalHeaderProps {
  children: ReactNode;
  onHide?: () => void;
  showCloseIcon?: boolean;
  isCloseBtnDisabled?: boolean;
}

const ModalHeader = ({ children, onHide, isCloseBtnDisabled = false, showCloseIcon = true }: ModalHeaderProps) => {
  return (
    <>
      {showCloseIcon && (
        <button
          disabled={isCloseBtnDisabled}
          className={styles.modal__header__close}
          onClick={onHide}
        >
          <img
            src={closeIcon}
            alt="close"
          />
        </button>
      )}
      <>{children}</>
    </>
  );
};

export default ModalHeader;
